import {
  LOGIN,
  FORGOT_PASSWORD,
  RESET_PASSWORD,
  // REGISTER
} from '../routes'

import LoginComponent from 'views/auth/login'
import ForgotPasswordComponent from 'views/auth/forgotPassword'
import ResetPasswordComponent from 'views/auth/resetPassword'
// import RegisterComponent from 'views/auth/register'

const authRoutes = [
  {
    path: '/',
    title: 'Login',
    component: LoginComponent,
  },
  {
    path: LOGIN,
    title: 'Login',
    component: LoginComponent,
  },
  {
    path: FORGOT_PASSWORD,
    title: 'Forgot Password',
    component: ForgotPasswordComponent,
  },
  {
    path: RESET_PASSWORD,
    title: 'Reset Password',
    component: ResetPasswordComponent,
  },
  // {
  //   path: REGISTER,
  //   title: 'Register',
  //   component: RegisterComponent,
  // },
]

export default authRoutes
